import tuc from 'temp-units-conv'

export default {
  methods: {
    // convert temperature from kelvins to degrees
    convertTemperature (kelvins, unit = 'C') {
      const conversion = unit === 'C' ? 'k2c' : unit === 'F' ? 'k2f' : null
      const degrees = conversion ? tuc[conversion](kelvins) : kelvins
      return Math.round(degrees)
    },
    // convert wind mesure m/s to km/h
    convertWind (ms) {
      return Math.round(ms * 3.6)
    }
  }
}
